import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../generic-ui/Pagination";
import Select from "../generic-ui/Select";
import NavbarIconsUsers from "../generic-nav-bar/NavbarIconsUsers";
import {
  userStartDelete,
  userStartSetBlocked,
  userStartActivateAccess,
  selectUser,
  startLoadingUsersPaginated,
  startSearchingUsersPaginated,
  cleanSearchingUsersPaginated,
  userCleanSearchText,
} from "../../app/actions/userActions";
import SearchBackUser from "../generic-search/SearchBackUser";

import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import TableUsers from "./TableUsers";
import { debugLogPages } from "../../app/helpers/debugHelper";

const ID_FORM = "admin-user";
const OPERATION = "list";

const listOptions = [2, 3, 4, 5, 10, 15, 20, 25, 50, 100];

const ListUsers = () => {
  debugLogPages(':: ListUser');

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const { searchTextState, usersS, usersP, totalPagesP, totalItemsP, currentPageP, totalPagesS, totalItemsS, currentPageS } =
    useSelector((state) => state.user);

  const [, setCurrentPageClick] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageInitial] = useState(0);
  const [searchText, setSearchText] = useState(searchTextState || "");
  const [accessFilter, setAccessFilter] = useState("all");

  const reloadUsers = (nextAccess = accessFilter, nextSize = itemsPerPage, nextSearch = searchText) => {
    if (nextSearch) {
      dispatch(startSearchingUsersPaginated(nextSearch, 0, nextSize, nextAccess));
    } else {
      dispatch(cleanSearchingUsersPaginated());
      dispatch(startLoadingUsersPaginated(0, nextSize, nextAccess));
    }
  };

  useEffect(() => {
    dispatch(cleanSearchingUsersPaginated());
    dispatch(userCleanSearchText());
    dispatch(startLoadingUsersPaginated(pageInitial, itemsPerPage, "all"));
    setSearchText("");
  }, []);

  const onEditRow = (row) => {
    trackEvent({ component: "EditUsers", method: "onEditRow", event: "EditUsers-Clicked" });

    row.passwordEncrypt = row.password;
    row.password = '';
    row.isChangedPassword = false;

    dispatch(selectUser(row));
    if (usersS && usersS.length > 0) {
      navigate("/admin-user/edit-user", {
        state: { searchTextNavListUser: searchText },
      });
    } else {
      navigate("/admin-user/edit-user");
    }
  };

  const onDeleteRow = (row) => {
    trackEvent({ component: "DeleteUsers", method: "onDeleteRow", event: "DeleteUsers-Clicked" });
    dispatch(userStartDelete(row.id));
  };

  const onBlockRow = (row) => {
    dispatch(userStartSetBlocked(row.id, !row.blocked, () => reloadUsers()));
  };

  const onActivateRow = (row) => {
    dispatch(userStartActivateAccess(row.id, () => reloadUsers()));
  };

  const onAccessFilter = (nextAccess) => {
    setAccessFilter(nextAccess);
    reloadUsers(nextAccess, itemsPerPage, searchText);
  };

  const onPageChange = (pageClick) => {
    
    if (usersS && usersS.length > 0) {
      dispatch(startSearchingUsersPaginated(searchText, pageClick - 1, itemsPerPage, accessFilter));
    } else {
      dispatch(startLoadingUsersPaginated(pageClick - 1, itemsPerPage, accessFilter));
    }
    setCurrentPageClick(pageClick);
  };

  const onChangeSelect = (event) => {
    setItemsPerPage(event.target.value);
    if (usersS && usersS.length > 0) {
      dispatch(startSearchingUsersPaginated(searchText, 0, event.target.value, accessFilter));
    } else {
      dispatch(startLoadingUsersPaginated(0, event.target.value, accessFilter));
    }
    setCurrentPageClick(0);
    setItemsPerPage(event.target.value);
  };

  return (
    <>
      <NavbarIconsUsers page={"listUser"} />

      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <div className="user-access-filters d-flex justify-content-center flex-wrap gap-2 mb-3">
        {[
          ["all", "filter-all"],
          ["login", "filter-login"],
          ["pending", "filter-pending"],
          ["blocked", "filter-blocked"],
        ].map(([value, labelKey]) => (
          <button
            key={value}
            type="button"
            className={`btn btn-sm ${accessFilter === value ? "btn-light" : "btn-outline-light"}`}
            onClick={() => onAccessFilter(value)}
          >
            {t(`${ID_FORM}.page.${labelKey}`)}
          </button>
        ))}
      </div>

      <SearchBackUser searchText={searchText} setSearchText={setSearchText} itemsPerPage={itemsPerPage} accessFilter={accessFilter} />

      {usersS && usersS.length > 0 ? (
        <TableUsers data={usersS} onEditRow={onEditRow} onDeleteRow={onDeleteRow} onBlockRow={onBlockRow} onActivateRow={onActivateRow} />
      ) : (
        <TableUsers data={usersP} onEditRow={onEditRow} onDeleteRow={onDeleteRow} onBlockRow={onBlockRow} onActivateRow={onActivateRow} />
      )}

      <div>
        <Select listOptions={listOptions} onChangeSelect={onChangeSelect} pageSize={itemsPerPage} />
      </div>

      <div className="pagination justify-content-center">
        {usersS && usersS.length > 0 ? (
          <Pagination
            totalPages={totalPagesS}
            totalItems={totalItemsS}
            currentPage={currentPageS + 1} 
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        ) : (
          <Pagination
            totalPages={totalPagesP}
            totalItems={totalItemsP}
            currentPage={currentPageP + 1} 
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        )}
      </div>
    </>
  );
};

export default ListUsers;
